import { httpGet } from "../Web";
import { ApiResponse } from "./ApiResponse";

export interface TestCase {
    id: number,
    guid: string,
    fieldSchema: string,
    fieldType: number,
    status: number,
    sortOrder: number,
    name: string,
    description?: string,
    group: string,
    interfaceId: number
};

export const TestcaseStatusStrings = ["Draft", "Released", "Disabled"];
export const TestcaseFieldTypeStrings = ["TextBox", "MultiLineBox", "CheckBox", "OptionList", "Table"];

export const getTestCases = (interfaceId: number, abortController: AbortController): Promise<ApiResponse<TestCase[]>> =>
    httpGet(`/api/interface/testcase/${interfaceId}`, abortController);

export const getTestCaseFromId = (testcase: number, abortController: AbortController): Promise<ApiResponse<TestCase>> =>
    httpGet(`/api/interface/testcasefromid/${testcase}`, abortController);

export const getTestCasesMap = async (interfaceId: number, abortController: AbortController): Promise<ApiResponse<Map<string, TestCase[]>>> => {
    try {
        const response = await getTestCases(interfaceId, abortController);
        const resultMap = new Map<string, TestCase[]>();

        if(!response.failed)
            response.result.forEach(testCase => {
                if(!resultMap.has(testCase.group))
                    resultMap.set(testCase.group, []);
                resultMap.get(testCase.group)!.push(testCase);
            })
        
        return {...response, result: resultMap}
    } catch(error) {
        return Promise.reject(error);
    }
}